import gql from 'graphql-tag';

export const START_SUBPRIME_AGENT_SESSION = gql`
  query StartSubprimeAgentSession($input: StartSubprimeAgentSessionInput!) {
    subprimeAgent {
      startSession(input: $input) {
        success
        message
      }
    }
  }
`;
